import { DatePipe } from "@angular/common";
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, ViewChild } from "@angular/core";
import { Constants } from "@app/constants/constants";
import { MethodsHelper } from "@app/helpers/methods.helper";
import { Branch } from "@app/models/branch";
import { GuaranteeAgreement } from "@app/models/guarantee-agreement";
import { AuthenticationService } from "@app/services/authentication.service";
import { BranchService } from "@app/services/branch.service";
import { GuaranteeService } from "@app/services/guarantee.service";
import { NotificationService } from "@app/services/notification.service";
import { TranslateService } from "@ngx-translate/core";

@Component({
    selector: 'app-guarantee-adjustment-popup',
    templateUrl: './guarantee-adjustment-popup.component.html',
    styleUrls: ['./guarantee-adjustment-popup.component.css'],
    standalone: false
})

export class GuaranteeAdjustmentPopupComponent implements OnInit, OnChanges {

    @Input() displayDialog: boolean;
    @Input() guaranteeAgreement: GuaranteeAgreement;
    @Output() onSubmit = new EventEmitter();
    @Output() onCancel = new EventEmitter();
    @Output() adjustmentReload = new EventEmitter();

    @ViewChild('form') form: any;

    guaranteeAdjustment: any;

    submittedForm: boolean = false;

    validationMessages: object;

    pageIndex = 0;
    pageSize = Constants.PAGE_ITEM_COUNT;
    totalElements: number;

    defaultPageParams = {
        size: 10,
        page: 0
    }

    yearRange: string;

    branchCodeList: Array<Branch>;


    constructor(
        private notificationService: NotificationService,
        private branchService: BranchService,
        private guaranteeService: GuaranteeService,
        private authenticationService: AuthenticationService,
        private datePipe: DatePipe,
        private translate: TranslateService
    ) {
    }

    ngOnInit() {
        if (!this.guaranteeAdjustment) {
            this.guaranteeAdjustment = new Object();
            this.guaranteeAdjustment.documentNumber = MethodsHelper.randomString(10);
            this.guaranteeAdjustment.guaranteeAgreementNumber = this.guaranteeAgreement.guaranteeAgreementNumber;
            this.guaranteeAdjustment.date = this.datePipe.transform(localStorage.getItem('businessDay') ? new Date(localStorage.getItem('businessDay')) : new Date(), 'dd-MM-yyyy');
            this.guaranteeAdjustment.channelCode = Constants.CHANNEL.CHANNEL_CODE;
            this.guaranteeAdjustment.currency = this.guaranteeAgreement.currency;
            this.guaranteeAdjustment.description = this.guaranteeAgreement.description;
            this.guaranteeAdjustment.initiatedUserId = this.authenticationService.getCurrentUserId();
            this.guaranteeAdjustment.branchId = this.guaranteeAgreement.branchId;
            this.guaranteeAdjustment.customerSpecificOptionsDtos = this.guaranteeAgreement.customerSpecificOptions;
            this.guaranteeAdjustment.purpose = this.guaranteeAgreement.guaranteeAgreementNumber + ' ' + 'guarantee adjustment';
        }
        this.validationMessages = new Object();
        this.yearRange = MethodsHelper.getYearRange(0);
        this.getBranches();
    }

    ngOnChanges() {
        this.getAdjustmentInfo();
    }

    getAdjustmentInfo() {
        this.guaranteeService.getAdjustmentInfo(this.guaranteeAgreement.id).subscribe({
            next: (data) => {
                this.guaranteeAdjustment.documentNumber = data.documentNumber;
                this.guaranteeAdjustment.guaranteeAgreementNumber = data.agreementNumber;
                this.guaranteeAdjustment.date = data.date;
                this.guaranteeAdjustment.currency = data.currency;
                this.guaranteeAdjustment.branchId = data.branchId;
                this.guaranteeAdjustment.purpose = data.purpose;
            },
            error: (err) => {
                let msg = MethodsHelper.showErrorMessageStyling(err);
                this.notificationService.showErrorMessage( `${msg}` );
            }
        });
    }

    getBranches() {
        const pageOption = {
            size: 10000,
            page: 0
        }
        const pageParams = { ...this.defaultPageParams, ...pageOption };
        this.branchService.getList(pageParams).subscribe(data => {
            this.branchCodeList = data.content;
            this.branchCodeList.forEach(code => {
                this.guaranteeAdjustment.branchId = JSON.parse(this.authenticationService.getUserRoles())[0]?.userBranchId;
            })
        });
    }

    onSave() {
        this.submittedForm = true;
        if (this.validateForm()) {
            this.guaranteeService.adjust(this.guaranteeAgreement.id, this.guaranteeAdjustment).subscribe({
                next: (data) => {
                    this.notificationService.showHTMLMessage("<i class='fa fa-check-circle' style='line-height: 2'></i> <p>" + `Successfully adjusted.` + "</p>", "");
                    this.cancel();
                    this.adjustmentReload.emit();
                },
                error: (err) => {
                    let msg = MethodsHelper.showErrorMessageStyling(err);
                    this.notificationService.showErrorMessage(`${msg}`);
                }
            });
        } else {
            this.notificationService.showError(this.translate.instant('error.something_incorrect'),9000);
        }
    }

    validateForm() {
        for (let key in this.validationMessages) {
            if (this.validationMessages[key]) {
                return false;
            }
        }
        if (!this.form.value.amount) {
            return false;
        }
        if (this.form.form) {
            return this.form.form.valid
        }
        return false;
    }

    cancel() {
        this.onCancel.emit();
    }

    changeBranch(value) {
        if (this.branchCodeList) {
            for (const element of this.branchCodeList) {
                if (element.id == value) {
                    this.guaranteeAdjustment.branchId = element.id;
                    break;
                }
            }
        }
    }

}
